import { render, staticRenderFns } from "./shareOrder6.vue?vue&type=template&id=61700715&scoped=true&"
import script from "./shareOrder6.vue?vue&type=script&lang=js&"
export * from "./shareOrder6.vue?vue&type=script&lang=js&"
import style0 from "./shareOrder6.vue?vue&type=style&index=0&id=61700715&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61700715",
  null
  
)

export default component.exports